export const siteSpecieDerivationOfEstimate = [
  { id: 1, name: 'maximum likelihood estimate from models' },
  { id: 2, name: 'median of multiple surveys' },
  { id: 3, name: 'mean of multiple surveys' },
  { id: 4, name: 'mid-point between min and max estimates' },
  { id: 5, name: 'estimated from single survey or assessment' },
  { id: 6, name: 'estimated from mapping' },
  { id: 7, name: 'other' }
]
